import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "sidebar-header",
  ref: "header"
}

import AppLogo from './AppLogo.vue'
import DrawerItem from './DrawerItem.vue'
import DrawerToggleButton from './DrawerToggleButton.vue'
import { ActionTypes } from 'src/types/stores/drawer'
import { computed, onMounted, ref } from 'vue'
import { menu, managerMenu } from 'src/config/menu'
import { useAuthStore } from 'src/stores/modules/auth'
import { useDrawerStore } from 'src/stores/modules/drawer'
import { useCarBodyPendingCountStore } from 'src/stores/modules/carbody/pending-count'


import { defineComponent } from 'vue'
const __default__ = defineComponent({ name: 'AppDrawer' })

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const drawerStore = useDrawerStore()
const authStore = useAuthStore()
const carBodyPendingCountStore = useCarBodyPendingCountStore()

onMounted(() => {
  if (authStore.userCan('car_body_prices_index')) {
    void carBodyPendingCountStore.fetch()
  }
})

// USER
const user = computed(() => authStore.user)
const userInitial = computed(() => {
  if (!user.value.name) return ''
  return user.value.name[0].toUpperCase()
})

// OPEN / CLOSE / MINI
const isOpen = computed(() => drawerStore.open)
const isMini = computed(() => drawerStore.mini)

//mini on mousover state
const mini = ref(drawerStore.mini)

function showMini(event: Event): void {
  const mouseEvent = event as MouseEvent & {
    target: Element
    relatedTarget?: Element
  }

  let target = mouseEvent.relatedTarget ?? mouseEvent.target

  while (target?.parentNode != null) {
    target = target.parentNode as Element
    if (target && target.id == 'sidebar') {
      return
    }
  }

  mini.value = true
}

function hideMini(): void {
  mini.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_drawer, {
    id: "sidebar",
    side: "left",
    class: "flex column",
    "mini-to-overlay": isMini.value,
    "model-value": isOpen.value,
    "onUpdate:modelValue": _unref(drawerStore)[_unref(ActionTypes).TOGGLE_OPEN],
    "show-if-above": isOpen.value,
    width: 250,
    breakpoint: 500,
    mini: isMini.value && mini.value,
    onMouseover: hideMini,
    onMouseout: showMini
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_toolbar, {
          class: _normalizeClass(
          mini.value && (!isOpen.value || isMini.value)
            ? 'bg-primary q-px-xs'
            : 'bg-grey-2 q-px-sm'
        )
        }, {
          default: _withCtx(() => [
            _createVNode(AppLogo, {
              size: mini.value && (!isOpen.value || isMini.value) ? 'xl' : 'lg'
            }, null, 8, ["size"]),
            (isOpen.value && (!isMini.value || !mini.value))
              ? (_openBlock(), _createBlock(DrawerToggleButton, {
                  key: 0,
                  class: "text-black q-ml-auto"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_q_expansion_item, { "expand-icon": "mdi-chevron-down" }, {
          header: _withCtx(() => [
            _createVNode(_component_q_item_section, {
              class: "q-py-sm",
              avatar: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_avatar, {
                  color: "primary",
                  "text-color": "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(userInitial.value), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "text-white" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.value.name ?? ''), 1)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_q_card, { class: "bg-accent text-white" }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  clickable: "",
                  to: { name: 'profile' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "mdi-account-circle-outline",
                          color: "grey-15"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("Profilo", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_ripple]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512),
      _createVNode(_component_q_scroll_area, {
        id: "sidebar-menu",
        class: "col-grow"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item, index) => {
                return (_openBlock(), _createBlock(DrawerItem, {
                  item: item,
                  key: `menu_${index}`
                }, null, 8, ["item"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(authStore).userCan('dashboard_manage'))
        ? (_openBlock(), _createBlock(_component_q_list, {
            key: 0,
            id: "sidebar-manager"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(managerMenu), (item, index) => {
                return (_openBlock(), _createBlock(DrawerItem, {
                  item: item,
                  key: `menu_${index}`
                }, null, 8, ["item"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_list, { ref: "footer" }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
            clickable: "",
            onClick: _unref(drawerStore)[_unref(ActionTypes).TOGGLE_MINI],
            class: "bg-blue-grey-10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isMini.value ? 'Mantieni aperto' : 'Minimizza'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section),
              _createVNode(_component_q_item_section, { side: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "mdi-menu-open",
                    color: "white",
                    class: _normalizeClass({ 'rotate-180': isMini.value })
                  }, null, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_ripple]
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["mini-to-overlay", "model-value", "onUpdate:modelValue", "show-if-above", "mini"]))
}
}

})